module.exports = __webpack_public_path__ + "images/confirm-payment-7ee3926751fa8be9412113bd4c592be3.svg";